import AppDispatcher from "../dispatcher/AppDispatcher"
import Constants from "../constants/Constants"
import config from 'react-global-configuration';
import 'whatwg-fetch'



var QuestionActions = {

  updateItem(name,value){

    AppDispatcher.dispatch({
      actionType: Constants.UPDATE_QUESTION,
      name:name,
      value:value
    })
  },

  create(item){

    const  request_data = {
      "name":item.name,
      "content":item.content,
      "mail":item.mail
    }


    fetch(config.get("API_PATH") + config.get("API_QUESTION"), {
      method: "POST",
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(request_data)
    }).then(function(response) {
      if(response.status === 200  ){
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
           return response.json()
         } else {
           return {"error":402}
        }
      }else{
        return  {"error":response.status}
      }
    }).then(function(data) {

      if(data && !data.error){
        window.location.href = "/sent"
      }else{
        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          message:config.get("ERROR_CREATE_GROUP")
        })
      }
    })
  },

}

export default QuestionActions
